import axios from 'axios'

export const companiesGmbAccount = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
  },
  mutations: {
    writeCompaniesGmbAccount(state) {
      state.loading = true
      state.loadError = false
    },
    writeCompaniesGmbAccountSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    writeCompaniesGmbAccountFailure(state) {
      state.loading = false
      state.loadError = true
    },
  },
  actions: {
    writeCompaniesGmbAccount({ commit, state }, payload) {
      if (state.loading) return false
      commit('writeCompaniesGmbAccount')
      commit('flash/clearFlash', null, { root: true })
      return axios
        .patch('/api/companies/'+ payload.companyUuid +'/gmb/accounts', payload)
        .then(res => {
          commit('writeCompaniesGmbAccountSuccess', res.data)
          return true
        })
        .catch(err => {
          commit('writeCompaniesGmbAccountFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
